<template>
  <UBadge
    v-if="tags?.some((tag) => tag.includes('bio'))"
    color="neutral"
    label="bio"
    class="mr-1 h-8 rounded-full bg-organic px-3 align-middle text-sm text-white shadow-sm"
  />
  <UBadge
    v-if="tags?.some((tag) => tag.includes('vegetarian'))"
    color="neutral"
    icon="i-mdi-leaf"
    class="h-8 rounded-full bg-organic px-3 align-middle text-white shadow-sm"
    :ui="{ leadingIcon: 'size-6' }"
  />
</template>

<script lang="ts" setup>
defineProps({
  tags: { type: Array, default: undefined },
});
</script>
